export default "__VITE_ASSET__DLkoxrTE__"